import type { CollaboratorResponseDtoT } from "../../domain/dtos/collaborator.dto";
import type { CollaboratorEntityT } from "../../domain/entities/collaborator.entity";
import type { GetAllCollaboratorsResponseT, CollaboratorsMapperT } from "../types/collaborators.types";

const mapItemToDomain = (item: CollaboratorResponseDtoT): CollaboratorEntityT => ({
  id: item.id,
  fullName: item.fullName,
  name: item.name,
  firstLastName: item.firstLastName,
  secondLastName: item.secondLastName,
  formattedCode: item.formattedCode,
  code: item.code,
  rfc: item.rfc,
  departmentId: item.departmentId,
  entryDate: item.entryDate,
  reEntryDate: item.reEntryDate,
  statusEmployee: item.statusEmployee,
  statusText: item.statusText,
  invitationStatus: item.invitationStatus,
  invitationSendingDate: item.invitationSendingDate,
  invitationResponseDate: item.invitationResponseDate,
  email: item.email,
  resend: item.resend,
  additionalInfo: item.additionalInfo,
  invalidEmail: item.invalidEmail,
  workShiftDetail: item.workShiftDetail,
});

export const collaboratorsMapper: CollaboratorsMapperT = {
  collaboratorsDtoToDomain: (rawData: GetAllCollaboratorsResponseT): CollaboratorEntityT[] => {
    const items: CollaboratorResponseDtoT[] = rawData?.results ?? [];

    return items.map(mapItemToDomain);
  },
};
